<template>
  <b-button variant="outline-danger" v-on:click="pressed">{{$t('DELETE')}}</b-button>
</template>
<script>
import { ajaxDelete } from "../../ajax";
import {apiUrl} from "@/main";

export default {
  props: ["UserID", "token"],
  methods: {
    pressed: function(event) {
      event.preventDefault();

      ajaxDelete(
        apiUrl() +"/users/" +
          parseInt(this.UserID),
        this.deleteSuccess,
        this.dataError,
        this.token
      );
    },
    deleteSuccess: function() {
      this.$emit("removeUser", this.UserID);
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }
    }
  }
};
</script>